import { Pipe, PipeTransform } from '@angular/core';
import { HighlightTestIds } from './highlight.test-ids';

@Pipe({
  name: 'highlight',
  standalone: true
})
export class HighlightPipe implements PipeTransform {
  transform(beforeHtml: string, afterHtml: string, author?: string): string {
    if (!beforeHtml && !afterHtml) return '';

    const beforeText = this.toPlainText(beforeHtml ?? '');
    const afterText = this.toPlainText(afterHtml ?? '');

    const diff = this.findDiff(this.normalize(beforeText), this.normalize(afterText));
    return this.highlightDiff(diff, afterHtml ?? '', author ?? null);
  }

  private toPlainText(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return (div.textContent || '').replaceAll(/\s+/g, ' ').trim();
  }

  private normalize(s: string): string {
    return s.replaceAll(/\s+/g, ' ').trim();
  }

  private findDiff(before: string, after: string): { value: string; added: boolean; removed: boolean }[] {
    const beforeWords = before ? before.split(' ') : [];
    const afterWords = after ? after.split(' ') : [];
    const diff: { value: string; added: boolean; removed: boolean }[] = [];
    let i = 0,
      j = 0;

    while (i < beforeWords.length || j < afterWords.length) {
      const beforeValue = beforeWords[i],
        afterValue = afterWords[j];
      if (beforeValue !== afterValue) {
        if (beforeValue && !afterValue) {
          diff.push({ value: beforeValue, added: false, removed: true });
          i++;
        } else if (!beforeValue && afterValue) {
          diff.push({ value: afterValue, added: true, removed: false });
          j++;
        } else {
          diff.push({ value: beforeValue, added: false, removed: true });
          diff.push({ value: afterValue, added: true, removed: false });
          i++;
          j++;
        }
      } else {
        diff.push({ value: beforeValue, added: false, removed: false });
        i++;
        j++;
      }
    }
    return diff;
  }

  private esc(s: string): string {
    return s.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;');
  }

  private toPlainTextKeepNewlines(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    const txt = div.textContent || '';
    return txt.replaceAll(/[ \t]+/g, ' ');
  }

  private highlightDiff(
    diff: { value: string; added: boolean; removed: boolean }[],
    afterHtml: string,
    author?: string | null
  ): string {
    const oldParts: string[] = [];
    diff.forEach(entry => {
      const value = this.esc(entry.value);
      if (entry.removed)
        oldParts.push(
          `<span data-testid="${HighlightTestIds.removedTextStyling}" style="text-decoration:line-through;color:#c62828;">${value}</span>`
        );
      else if (!entry.added) oldParts.push(`<span>${value}</span>`);
    });
    const oldHtml = oldParts.join(' ');
    let afterPlain = this.esc(this.toPlainTextKeepNewlines(afterHtml));
    // Entferne Zeilenumbr�che am Ende
    while (afterPlain.endsWith('\r') || afterPlain.endsWith('\n')) {
      afterPlain = afterPlain.slice(0, -1);
    }

    const authorHtml = author ? `<strong class="author">${this.esc(author)}</strong>` : '';

    return `
  <div class="msg-history">
    <div class="msg-row msg-diff" data-testid="${HighlightTestIds.originalContent}">
      <span class="msg-body" data-testid="${HighlightTestIds.originalText}">&quot;${oldHtml}&quot;</span>-<span data-testid="${HighlightTestIds.originalAuthor}">${authorHtml}</span>
    </div>
    <div class="msg-row msg-final" data-testid="${HighlightTestIds.changedContent}">
      <span class="msg-body" data-testid="${HighlightTestIds.changedText}">&quot;${afterPlain}&quot;</span>-<span data-testid="${HighlightTestIds.changedAuthor}">${authorHtml}</span>
    </div>
  </div>`;
  }
}
